import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonLoader = () => {
  const cardCount = 6;

  const skeletonRows = Array(cardCount).fill(0);

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8">
      <div className="overflow-x-auto w-full">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-hidden shadow ring-1 ring-gray-900/5">
            <table className="min-w-full divide-y divide-gray-300 w-full">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="w-52 px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    <Skeleton width={80} />
                  </th>
                  <th
                    scope="col"
                    className="w-52 px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    <Skeleton width={120} />
                  </th>
                  <th
                    scope="col"
                    className="w-52 px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    <Skeleton width={80} />
                  </th>
                  <th
                    scope="col"
                    className="w-52 px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    <Skeleton width={120} />
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 ">
                {skeletonRows.map((_, index) => (
                  <tr key={index}>
                    <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
                      <Skeleton circle={true} height={50} width={50} />
                    </td>
                    <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                      <Skeleton count={1} />
                    </td>
                    <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                      <Skeleton count={1} />
                    </td>
                    <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                      <Skeleton count={1} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoader;
